module.exports = __webpack_public_path__ + "static/media/trimex_supremacompleta.38120903.png";